import { sendParent } from '@monofront/xstate-v4';
import { SELECT_ADDRESS_TRANSITIONS } from '../transitions';
import { IAddressModalContext, ISubmitAddressModalEvent } from './types';

export const sendSubmitAddressFormToParent = sendParent<
  IAddressModalContext,
  ISubmitAddressModalEvent
>((context, event) => ({
  type: context.update
    ? SELECT_ADDRESS_TRANSITIONS.UPDATE_ADDRESS
    : SELECT_ADDRESS_TRANSITIONS.CREATE_ADDRESS,
  address: { ...event.address, id: context.defaultAddress?.id },
  creatingForBillingOnly: event.creatingForBillingOnly,
}));

export enum ADDRESS_MODAL_EXTERNAL_ACTIONS {
  trackOpenModal = 'trackOpenModal',
  trackCloseModal = 'trackCloseModal',
}
